export enum DatabaseCollection {
  CLIENTS = "clients",
  VENDORS = "vendors",
  CONFIGS = "configs",
  PROMO_CODES = "promo-codes",
  USERS = "users",
  PRODUCTS = "products",
  CUSTOMERS = "customers",
  EVENTS = "events",
  DEALS = "deals",
  CUSTOMER_METRICS = "customer-metrics",
  AUDIT_LOGS = "audit-logs",
  REPORTS = "reports",
  INVENTORIES = "inventories",
  ORDER_CANDIDATES = "order-candidates",
  PURCHASE_ORDERS = "purchase-orders",
  SALES_ORDERS = "sales-orders",
  BOOKINGS = "bookings",
  STOCK_CHECKS = "stock-checks",
  ACCOUNT_ISSUES = "account-issues",
  INVOICES = "invoices",
  PAYMENTS = "payments",
  INVENTORY_LEDGER = "inventory-ledger",
  NOTE_TEMPLATES = "note-templates",
  SPECIAL_ATTRIBUTES = "special-attributes",
  PAYPAL_PAYMENTS = "paypal-payments",
  MERCURY_PAYMENTS = "mercury-payments",
  MERCURY_BALANCE_SNAPSHOTS = "mercury-balance-snapshots",
  AIRWALLEX_PAYMENTS = "airwallex-payments",
  AIRWALLEX_BALANCE_SNAPSHOTS = "airwallex-balance-snapshots",
  BLOCKED_CONTACTS = "blocked-contacts",
}
